import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLoja } from './LojaContext';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Card } from '../../components/ui/card';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { Store } from 'lucide-react';

export default function LojaRegister() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { register } = useLoja();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast.error('Senha mínima: 6 caracteres'); return; }
    setLoading(true);
    try {
      await register(form.name, form.email, form.password, form.phone);
      toast.success('Conta criada!');
      navigate('/loja');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Falha no cadastro');
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="text-center mb-6">
        <div className="inline-flex w-16 h-16 bg-gradient-to-br from-fuchsia-500 to-purple-600 rounded-2xl items-center justify-center shadow-lg shadow-fuchsia-500/30 mb-4">
          <Store className="w-8 h-8 text-white" strokeWidth={2.5} />
        </div>
        <h1 className="text-2xl font-black">Criar conta</h1>
        <p className="text-sm text-slate-400">Junte-se à loja MARKIMAGEM</p>
      </div>
      <Card className="bg-slate-900 border-slate-800 p-6">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div><Label>Nome</Label><Input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required className="bg-slate-800 border-slate-700" /></div>
          <div><Label>Email</Label><Input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required className="bg-slate-800 border-slate-700" /></div>
          <div><Label>Telefone (opcional)</Label><Input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} className="bg-slate-800 border-slate-700" /></div>
          <div><Label>Senha</Label><Input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required minLength={6} className="bg-slate-800 border-slate-700" /></div>
          <Button type="submit" disabled={loading} className="w-full bg-fuchsia-500 hover:bg-fuchsia-600">{loading ? 'Criando...' : 'Criar conta'}</Button>
        </form>
        <p className="text-center text-sm text-slate-400 mt-4">Já tem conta? <Link to="/loja/login" className="text-fuchsia-400 hover:text-fuchsia-300">Entrar</Link></p>
      </Card>
    </div>
  );
}
